<template>
  <div class="chat-bot">


    <div  class="chat-window">
      <div class="chat-header">
        <h5>🤖 دستیار هوشمند</h5>
        <button @click="clearChat" class="btn btn-sm btn-secondary">پاک کردن</button>
      </div>

      <div class="chat-messages" ref="messagesContainer">
        <div v-for="(msg, index) in messages" :key="index"
             :class="['message', msg.role]">
          <div class="message-content" v-html="msg.content"></div>
        </div>
        <div v-if="loading" class="message assistant">
          <div class="typing-indicator">...</div>
        </div>
      </div>

      <div class="chat-input">
        <textarea v-model="inputMessage"
                  @keydown.enter.prevent="sendMessage"
                  placeholder="پیام خود را بنویسید..."
                  rows="2"
                  :disabled="loading"></textarea>
        <button @click="sendMessage" :disabled="loading || !inputMessage.trim()">
          ارسال
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ChatBot',
  data() {
    return {
      isOpen: false,
      loading: false,
      inputMessage: '',
      messages: [],
      sessionId: localStorage.getItem('chat_session_id') || null
    }
  },
  mounted() {
    if (!this.sessionId) {
      this.sessionId = this.generateSessionId();
      localStorage.setItem('chat_session_id', this.sessionId);
    }
    this.loadHistory();
  },
  methods: {
    generateSessionId() {
      return 'chat_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },

    toggleChat() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.scrollToBottom();
      }
    },

    async loadHistory() {
      try {
        const response = await axios.post('/api/admin/chat/history', { session_id: this.sessionId });
        this.messages = response.data.history || [];
        this.scrollToBottom();
      } catch (error) {
        console.error('Error loading chat history:', error);
      }
    },

    async sendMessage() {
      if (!this.inputMessage.trim() || this.loading) return;

      const message = this.inputMessage.trim();
      this.messages.push({ role: 'user', content: message });
      this.inputMessage = '';
      this.loading = true;

      try {
        const response = await axios.post('/api/admin/chat/send', {
          message: message,
          session_id: this.sessionId
        },{show_pros:false});

        this.messages.push({ role: 'assistant', content: response.data.response });
        this.scrollToBottom();
      } catch (error) {
        console.error('Error sending message:', error);
        this.messages.push({
          role: 'assistant',
          content: '❌ خطا در ارتباط با AI. لطفاً دوباره تلاش کنید.'
        });
      } finally {
        this.loading = false;
        this.scrollToBottom();
      }
    },

    async clearChat() {
      if (!confirm('آیا از پاک کردن تاریخچه چت مطمئن هستید؟')) return;

      try {
        await axios.delete('/api/admin/chat/history', {
          params: { session_id: this.sessionId }
        });
        this.messages = [];
        localStorage.removeItem('chat_session_id');
        this.sessionId = this.generateSessionId();
        localStorage.setItem('chat_session_id', this.sessionId);
      } catch (error) {
        console.error('Error clearing chat:', error);
      }
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  }
}
</script>

<style scoped>
.chat-bot {
  //position: fixed;
  //bottom: 20px;
  //right: 20px;
  //z-index: 10000;
}

.chat-toggle {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(102,126,234,0.4);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-toggle:hover {
  transform: scale(1.05);
}

.chat-window {
  width: 100%;
  height: 400px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-header {
  padding: 15px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-header h5 {
  margin: 0;
  font-size: 16px;
}

.chat-messages {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  background: #f8f9fa;
}

.message {
  margin-bottom: 10px;
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
}

.message.user {
  background: #667eea;
  color: white;
  margin-left: auto;
  border-bottom-right-radius: 4px;
}

.message.assistant {
  background: white;
  color: #1f2937;
  margin-right: auto;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.typing-indicator {
  color: #9ca3af;
  animation: blink 1.4s infinite;
}

@keyframes blink {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}

.chat-input {
  padding: 10px;
  border-top: 1px solid #e5e7eb;
  background: white;
  display: flex;
  gap: 8px;
}

.chat-input textarea {
  flex: 1;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  resize: none;
  font-family: inherit;
}

.chat-input textarea:focus {
  outline: none;
  border-color: #667eea;
}

.chat-input button {
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.chat-input button:hover:not(:disabled) {
  background: #5a67d8;
}

.chat-input button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .chat-window {
    width: 100vw;
    height: 100vh;
    bottom: 0;
    right: 0;
    border-radius: 0;
  }
}
</style>